import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "u-cookies"
}
const _hoisted_2 = { class: "row justify-end" }
const _hoisted_3 = { class: "col-auto col-lg-4 offset-lg-8 col-xl-4 offset-xl-8 col-xxl-8 offset-xxl-1" }
const _hoisted_4 = { class: "u-cookies__body" }
const _hoisted_5 = { class: "u-cookies__subbody" }
const _hoisted_6 = { class: "u-cookies__content" }
const _hoisted_7 = ["href"]
const _hoisted_8 = { class: "col-12 col-lg-auto align-self-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock(_Transition, { name: "q-transition--jump-left" }, {
    default: _withCtx(() => [
      (_ctx.forceToAccept)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, [
                _createElementVNode("div", _hoisted_4, [
                  _createElementVNode("div", _hoisted_5, [
                    _cache[5] || (_cache[5] = _createElementVNode("div", { class: "u-cookies__title" }, [
                      _createTextVNode(" Используем файлы "),
                      _createElementVNode("b", null, "cookie"),
                      _createTextVNode(" и сервис "),
                      _createElementVNode("b", null, "Яндекс.Метрика")
                    ], -1)),
                    _createElementVNode("div", _hoisted_6, [
                      _cache[1] || (_cache[1] = _createTextVNode(" Это помогает сайту работать лучше. Продолжая работу на сайте, вы соглашаетесь с использованием файлов cookie и обработкой персональных данных в соответствии с нашим ")),
                      _createElementVNode("a", {
                        href: _ctx.STATIC_DOCS.REGULATIONS_ON_PERSONAL_DATA_PROCESSING.url,
                        class: "u-cookies__link",
                        target: "_blank",
                        rel: "noopener noreferrer"
                      }, " Положением об обработке ПДн", 8, _hoisted_7),
                      _cache[2] || (_cache[2] = _createTextVNode(". ")),
                      _cache[3] || (_cache[3] = _createElementVNode("br", null, null, -1)),
                      _cache[4] || (_cache[4] = _createTextVNode(" Вы можете отключить файлы cookie в настройках браузера. "))
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_8, [
                    _createElementVNode("button", {
                      class: "u-cookies__btn",
                      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.acceptCookies && _ctx.acceptCookies(...args)))
                    }, "Принять")
                  ])
                ])
              ])
            ])
          ]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}